import ProposalCreator from "./views/Proposals";
import { SnackbarProvider } from "notistack";

function App() {
  return (
    <div className="App" style={{ textAlign: "center" }}>
      <SnackbarProvider
        maxSnack={3}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <ProposalCreator />
      </SnackbarProvider>
    </div>
  );
}

export default App;
